import { render, staticRenderFns } from "./UserTableView.vue?vue&type=template&id=92f1e60c&scoped=true"
import script from "./UserTableView.vue?vue&type=script&lang=ts"
export * from "./UserTableView.vue?vue&type=script&lang=ts"
import style0 from "./UserTableView.vue?vue&type=style&index=0&id=92f1e60c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92f1e60c",
  null
  
)

export default component.exports